// @ts-nocheck
import { BlockParsedBaseProps } from "@store/Library/Components/Toolkit/Block/Block";
import { BlockVariantBaseProps, BlockVariantTypeProps } from "@store/Library/Components/Toolkit/Block/variant/base";
import { clearfixStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { blockContainerClearFixStyles } from "@store/Library/Components/Toolkit/Block/mixins";
/* Store Custom Code - End */

export interface BlockVariantBackgroundBaseProps {}
export interface BlockVariantBackgroundProps extends BlockVariantBaseProps, BlockVariantBackgroundBaseProps {}

const typeProps: BlockVariantTypeProps<BlockVariantBackgroundProps> = {
    defaultProps: {},
    staticProps: {
        containerCss: css<BlockParsedBaseProps>`
            ${blockContainerClearFixStyles() /* Store Custom Code */}
        `,
    },
};

export default typeProps;
